// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h4[data-v-e056adf2]{border-right:4px solid var(--v-primary-base);padding-right:8px;font-size:1rem}", ""]);
// Exports
module.exports = exports;
